import PropTypes from 'prop-types';
import styles from './style.module.scss';

const propTypes = {
  inputText: PropTypes.string.isRequired,
  highlightPart: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])])
};

const HighlightedTextComponent = ({inputText, highlightPart} = {}) => {
  const highlightClass = styles['highlighted-text__bold'];

  const getHighlightedTextPart = part => `<span class=${highlightClass}>${part}</span>`;

  // Skip highlighting if highlightPart is empty
  const html = highlightPart
    ? inputText.replace(new RegExp(highlightPart, 'ig'), getHighlightedTextPart)
    : inputText;

  return (
    <span className={styles['highlighted-text']} dangerouslySetInnerHTML={{__html: html}} />
  );
};

HighlightedTextComponent.propTypes = propTypes;

export default HighlightedTextComponent;
